import { z } from 'zod';

export const ConditionViolationHistoryPointSchema = z.tuple([
  z.date(),
  z.number().optional(),
]);

export type ConditionViolationHistoryPoint = z.infer<
  typeof ConditionViolationHistoryPointSchema
>;

export const ConditionViolationHistorySeriesSchema = z.object({
  points: z.array(ConditionViolationHistoryPointSchema),
});

export type ConditionViolationHistorySeries = z.infer<
  typeof ConditionViolationHistorySeriesSchema
>;

export const ConditionViolationSchema = z.object({
  id: z.string(),
  description: z.string(),
  extremeValue: z.number(),
  extremeValueUnit: z.string(),
  lastDetectedAt: z.date(),
  durationHours: z.number(),
  affectedUnitsCount: z.number(),
  historySeries: ConditionViolationHistorySeriesSchema,
});

export type ConditionViolation = z.infer<typeof ConditionViolationSchema>;
